import React from "react";
import { Navigate, Outlet, createBrowserRouter } from "react-router-dom";
import Login from "./pages/Login";
import "react-toastify/dist/ReactToastify.css";
import Homepage from "./pages/Homepage";
import SubadminAccess from "./pages/SubadminAccess";
import Kyc from "./pages/Kyc";
import Footer from "./Components/Footer";
import AddSubAdmin from "./pages/AddSubAdmin";
import Subadmin from "./pages/Subadmin";
import ErrorPage from "./pages/ErrorPage";
import { jwtDecode } from "jwt-decode";
import OrdersHistory from "./pages/OrdersHistory";
import EditSubadmin from "./pages/EditSubadmin";
import ScrollToTop from "./Components/ScrollToTop";
import Settings from "./pages/Settings";
import Transction from "./pages/Transction";
import Singletransction from "./pages/Singletransction";
import RoiHistory from "./pages/RoiHistory";
import Upload from "./pages/Upload";
import Subscribe from "./pages/subscribe";
import Tickets from "./pages/Tickets";
import TicketsD from "./pages/TicketsD";
import Enquiry from "./pages/Enquiry";
import FiatHistory from './pages/FiatTransfers'

const isAuthenticated = () => {
  const token = localStorage.getItem("token");
  if (token === null || token === undefined) {
    console.log("tokentundefinedoken", token);
    return false;
  } else {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  }
};

const isAdmin = () => {
  const role = localStorage.getItem("role");
  return role === "admin";
};

const ProtectedRoute = () => {
  return isAuthenticated() ? <App /> : <Navigate to={"/login"} />;
};

const AdminRoute = () => {
  return isAdmin() ? <Outlet /> : <Navigate to={"/"} />;
};

const App = () => {
  return (
    <>
      <ScrollToTop />
      <Outlet />
      <Footer />
    </>
  );
};

export const router = createBrowserRouter([
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "/",
        element: <Homepage />,
      },
      {
        // element: <AdminRoute />,
        children: [
          {
            path: "/subadmin-access",
            element: <SubadminAccess />,
          },
          {
            path: "/subadmin",
            element: <Subadmin />,
          },
          {
            path: "/subadmin/add-new",
            element: <AddSubAdmin />,
          },
          {
            path: "/subadmin/:id",
            element: <EditSubadmin />,
          },
        ]
      },
      {
        path: "/user/:id",
        element: <Kyc />,
      },
      {
        path: "/order-history",
        element: <OrdersHistory />,
      },
       {
        path: "/transaction",
        element: <Transction />,
      },
      {
        path: "/transaction/:id",
        element: <Singletransction />,
      },
      {
        path: "/settings",
        element: <Settings />,
      },
      {
        path: "/roi_history",
        element: <RoiHistory />,
      },
      {
        path: "/subscribe",
        element: <Subscribe />,
      },
      {
        path: "/upload",
        element: <Upload />,
      },
      {
        path: "/tickets",
        element: <Tickets />,
      },
      {
        path: "/tickets/:id",
        element: <TicketsD />,
      },
      {
        path: "/enquiry",
        element: <Enquiry />,
      },
      {
        path: "/fiat",
        element: <FiatHistory />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
